<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Metas Personales</li>
</ol>

<h1 class="page-header"><i class="fas fa-bullseye"></i> {{module?.name || 'Evaluación'}}<small> Metas personales por entidad</small></h1>

<div class="scrollable">
  <panel [noButton]="true">
    <div class="row mb-4">
      <div class="col-md-3">
        Grupo
        <ng-select [items]="groups" bindLabel="name" [(ngModel)]="selectedGroup" (ngModelChange)="onGroupChange()"></ng-select>
      </div>
      <div class="col-md-2">
        Año
        <select class="form-select" [(ngModel)]="yearSelected" (ngModelChange)="onYearChange()">
          @for(y of years; track y){
          <option [value]="y">{{y}}</option>
          }
        </select>
      </div>
      <div class="col-md-4">
        Entidad
        <ng-select [items]="entities" bindLabel="name" [(ngModel)]="selectedEntity"
          (ngModelChange)="onEntityChange()" placeholder="Seleccione una entidad..."></ng-select>
      </div>
    </div>

    @if (!selectedEntity) {
    <div class="text-center py-5 text-muted">
      <i class="fas fa-hand-pointer fs-1 mb-3 d-block"></i>
      <span>Seleccione una entidad para fijar las metas personales</span>
    </div>
    }

    @if (selectedEntity) {
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th class="text-center" style="width:70px">N°</th>
          <th>Categoría</th>
          <th>Pregunta</th>
          <th class="text-center" style="width:150px">
            <span triggers="hover" ngbTooltip="Valor a alcanzar">Meta</span>
          </th>
          <th class="text-center" style="width:120px"><i class="fas fa-cogs"></i></th>
        </tr>
      </thead>
      <tbody>
        @for(q of personalQuestions; track q.id){
        <tr>
          <td class="text-center text-muted small fw-600">{{q.numberLabel}}</td>
          <td class="text-muted small">{{q.categoryName}}</td>
          <td class="fw-500">
            @if (q.parentTitle) {
            <span class="text-muted small d-block">{{q.parentTitle}}</span>
            }
            {{q.title}}
          </td>
          <td class="text-center">
            @if (q.isPersonal) {
              @if (editingQuestionId() === q.id) {
              <input type="text" class="form-control form-control-sm text-end"
                [(ngModel)]="q.targetValue" placeholder="Valor de la meta" />
              }@else {
              <span class="fw-600">{{ q.targetValue ?? '—' }}</span>
              }
            }@else {
            <span class="fw-600" triggers="hover" ngbTooltip="Definida por la UCh">{{q.goalValue ?? '—'}}</span>
            }
          </td>
          <td class="text-center text-nowrap">
            @if (q.isPersonal) {
              @if (editingQuestionId() === q.id) {
              <button class="btn btn-xs btn-primary me-1" (click)="saveGoal(q)" triggers="hover" ngbTooltip="Guardar meta">
                <i class="fas fa-save"></i>
              </button>
              <button class="btn btn-xs btn-ghost me-1" (click)="cancelEdit(q)" triggers="hover" ngbTooltip="Cancelar">
                <i class="fas fa-xmark"></i>
              </button>
              }@else {
              <button class="btn btn-xs btn-ghost me-1" (click)="startEdit(q)" [disabled]="!selectedEntity"
                triggers="hover" ngbTooltip="Editar meta">
                <i class="fas fa-edit"></i>
              </button>
              }
            }
            <button class="btn btn-xs btn-ghost me-1" (click)="openHistory(historyModal, q)" triggers="hover" ngbTooltip="Historial de cambios">
              <i class="fas fa-clock-rotate-left"></i>
            </button>
            @if (q.isPersonal && goalFor(q.id) && editingQuestionId() !== q.id) {
            <button class="btn btn-xs btn-ghost" (click)="removeGoal(q)" triggers="hover" ngbTooltip="Eliminar meta">
              <i class="fas fa-trash"></i>
            </button>
            }
          </td>
        </tr>
        }@empty {
        <tr><td colspan="5" class="text-center text-muted">No hay preguntas con meta personal en este módulo/año</td></tr>
        }
      </tbody>
    </table>
    }
  </panel>
</div>

<ng-template #historyModal let-d="dismiss">
  <div class="modal-header">
    <span class="fs-3 fw-700"><i class="fas fa-clock-rotate-left me-2"></i>Historial de cambios</span>
  </div>
  <div class="modal-body">
    @if (historyQuestion) {
    <p class="mb-1 fw-600">{{ historyQuestion.title }}</p>
    <p class="text-muted small">
      {{ historyQuestion.isPersonal ? 'Entidad: ' + (selectedEntity?.name || '—') + ' · ' : '' }}Año: {{ yearSelected }}
    </p>
    }
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Usuario</th>
          <th class="text-end">Valor inicial</th>
          <th class="text-end">Valor final</th>
        </tr>
      </thead>
      <tbody>
        @for(h of historyRows; track h.id){
        <tr>
          <td>{{ h.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ h.user?.displayName || h.user?.mail || '—' }}</td>
          <td class="text-end">{{ h.oldValue ?? '—' }}</td>
          <td class="text-end fw-600">{{ h.newValue ?? 'Eliminada' }}</td>
        </tr>
        }@empty {
        <tr><td colspan="4" class="text-center text-muted">Sin cambios registrados</td></tr>
        }
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="d('Cross click')">Cerrar</button>
  </div>
</ng-template>
